import { useContext } from "react";
import { PeopleContext } from "@shapeable/ui";

export const usePeople = () => useContext(PeopleContext);
